export default __webpack_public_path__ + "static/media/logout.34972ed2.svg";